<template>
    <v-container fluid>
        <h1>{{saludar()}}, {{authUser.name}}</h1>
        <v-row justify="center">
            <v-col cols="12">
                <v-card :loading="loading" class="pb-3">
                    <v-card-title class="justify-center">
                       <p>Semana del {{semana.lunes}} al {{semana.viernes}} 
                            <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fecha" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon 
                                        v-bind="attrs" 
                                        v-on="on" 
                                        @blur="fecha = parseDate(fechaFormateada)" 
                                        color="primary"
                                        class="ml-2"
                                    >
                                        mdi-calendar-edit
                                    </v-icon>
                                </template>
                                <v-date-picker v-model="fecha" scrollable :first-day-of-week="1">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialogFecha.save(fecha), calcularSemana()">Aceptar</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </p>
                    </v-card-title>

                    <v-row class="ml-8 mr-8">
                        <v-col cols="12" md="1"></v-col>
                        <v-col cols="12" sm="4" md="2" align="center">
                            <div style="max-width: 100px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Lunes {{parseInt(semana.lunes.substr(0, 2))}}</span>
                                    </template>
                                    <span v-if="facturacionDiaria.lunes != 0">{{facturacionDiaria.lunes.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.lunes == 0">No se han imputado horas</span>
                                </v-tooltip>         
                                <v-progress-circular
                                    class="mt-3"
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos?  porcentajeFacturacion.lunes : 0"
                                    :color="getColor(porcentajeFacturacion.lunes)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.lunes.toFixed(2)}}%</div>
                                </v-progress-circular>
                            </div>
                        </v-col> 
                        <v-col cols="12" sm="4" md="2" align="center">
                            <div style="max-width: 100px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Martes {{parseInt(semana.martes.substr(0, 2))}}</span>
                                    </template>
                                    <span v-if="facturacionDiaria.martes != 0">{{facturacionDiaria.martes.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.martes == 0">No se han imputado horas</span>
                                </v-tooltip>
                                
                                <v-progress-circular
                                    class="mt-3"
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos? porcentajeFacturacion.martes : 0"
                                    :color="getColor(porcentajeFacturacion.martes)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.martes.toFixed(2)}}%</div>
                                </v-progress-circular>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="2" align="center">
                            <div style="max-width: 100px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Miércoles {{parseInt(semana.miercoles.substr(0, 2))}}</span>
                                    </template>
                                    <span v-if="facturacionDiaria.miercoles != 0">{{facturacionDiaria.miercoles.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.miercoles == 0">No se han imputado horas</span>
                                </v-tooltip>
                                
                                <v-progress-circular
                                    class="mt-3"
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos?  porcentajeFacturacion.miercoles : 0"
                                    :color="getColor(porcentajeFacturacion.miercoles)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.miercoles.toFixed(2)}}%</div>
                                </v-progress-circular> 
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="2" align="center">
                            <div style="max-width: 100px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Jueves {{parseInt(semana.jueves.substr(0, 2))}}</span>
                                    </template>
                                    <span v-if="facturacionDiaria.jueves != 0">{{facturacionDiaria.jueves.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.jueves == 0">No se han imputado horas</span>
                                </v-tooltip>
                                
                                <v-progress-circular
                                    class="mt-3"    
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos? porcentajeFacturacion.jueves : 0"
                                    :color="getColor(porcentajeFacturacion.jueves)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.jueves.toFixed(2)}}%</div>
                                </v-progress-circular>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="2" align="center">
                            <div style="max-width: 100px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Viernes {{parseInt(semana.viernes.substr(0, 2))}}</span>
                                    </template>
                                    <span v-if="facturacionDiaria.viernes != 0">{{facturacionDiaria.viernes.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.viernes == 0">No se han imputado horas</span>
                                </v-tooltip>
                                
                                <v-progress-circular
                                    class="mt-3"
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos? porcentajeFacturacion.viernes : 0"
                                    :color="getColor(porcentajeFacturacion.viernes)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.viernes.toFixed(2)}}%</div>
                                </v-progress-circular>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="12" align="center">
                            <div style="max-width: 150px;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Media Semanal</span>
                                    </template>
                                    <span v-if="facturacionDiaria.mediaSemanal != 0">{{facturacionDiaria.mediaSemanal.toFixed(2)}} horas ponderadas</span>
                                    <span v-if="facturacionDiaria.mediaSemanal == 0">No se han imputado horas</span>
                                </v-tooltip>
                                <v-progress-circular
                                    class="mt-3"
                                    :rotate="-90"
                                    :size="100"
                                    :width="7"
                                    :value="cargarCirculos? porcentajeFacturacion.mediaSemanal : 0"
                                    :color="getColor(porcentajeFacturacion.mediaSemanal)"
                                >
                                    <div :style="this.$vuetify.theme.dark? 'color:white' : 'color:black'">{{porcentajeFacturacion.mediaSemanal.toFixed(2)}}%</div>
                                </v-progress-circular>  
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <Fidelizaciones />
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-card :loading="loading" class="pa-3 pt-0">
                    <v-card-title>Partes en seguimiento</v-card-title>
                    <v-data-table 
                        :headers="headersPartesFollowed" 
                        :items="partesFollowed">
                        <template v-slot:item.acciones="{ item }">
                            <v-btn icon link :href="`${v3Url}/partes/${item.id}`">
                                <v-icon>mdi-launch</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-card :loading="loading" class="pa-3 pt-0">
                    <v-card-title>Clientes mas facturados<h6 class="ml-1">(últimos 30 días)</h6></v-card-title>
                    <v-data-table 
                        :headers="headersClientes" 
                        :items="facturacionClientes"                  
                        hide-default-header
                        hide-default-footer>
                        <template v-slot:item.medalla="{ item }">
                            <v-icon v-if="item == facturacionClientes[0]" color="yellow">mdi-medal-outline</v-icon>
                            <v-icon v-if="item == facturacionClientes[1]" color="grey">mdi-medal-outline</v-icon>
                            <v-icon v-if="item == facturacionClientes[2]" color="brown">mdi-medal-outline</v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-card :loading="loading" class="pa-3 pt-0">
                    <v-card-title>
                        Timers <v-spacer></v-spacer>
                        <v-btn icon link :to="{name: 'arditimer'}" >
                            <v-icon>mdi-launch</v-icon>
                        </v-btn>
                    </v-card-title>
                    <p class="ml-4 mb-0">{{timersUsuario}}</p>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import formatearFecha from '../../mixins/formatearFecha';
import axios from 'axios';
import Fidelizaciones from "./Fidelizaciones";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'Dasboard',
    mixins: [formatearFecha],
    data: () => ({
        loading: false,
        dialogFecha: false,
        modalFecha: false,
        fechaFormateada: null,
        fecha: '',
        partesFollowed: [],
        facturacionClientes: [],
        timersUsuario: '',
        accionesUsuario: [],
        horasDiarias: {
            lunes: 8.5,
            martes: 8.5,
            miercoles: 8.5,
            jueves: 8.5,
            viernes: 6,
        },
        facturacionDiaria:{
            lunes: 0,
            martes: 0,
            miercoles: 0,
            jueves: 0,
            viernes: 0,
            mediaSemanal: 0
        },
        porcentajeFacturacion: {
            lunes: 0,
            martes: 0,
            miercoles: 0,
            jueves: 0,
            viernes: 0,
            mediaSemanal: 0
        },
        semana: {},
        cargarCirculos: false,
        headersPartesFollowed: [
            {
                text: 'Núm. Parte',
                filterable: false,
                value: 'numParte',
            },
            {
                text: 'Cliente',
                filterable: false,
                value: 'cliente',
            },
            {
                text: 'Concepto',
                filterable: false,
                value: 'concepto',
            },
            {
                text: 'Fecha vto.',
                filterable: false,
                value: 'fechaVto',
            },
            {
                text: 'Acciones',
                filterable: false,
                align: 'center',
                sortable: false,
                value: 'acciones'
            }
        ],
        headersClientes: [
            {
                align: 'center',
                value: 'medalla'
            },
            {
                filterable: false,
                value: 'cliente',
            },
            {
                filterable: false,
                value: 'facturacion',
            },
        ],
        v3Url: process.env.VUE_APP_V3_URL
    }),
    async created(){
        this.fechaFormateada = this.formatDate(new Date().toISOString().substr(0, 10));
        this.fecha = this.parseDate(this.fechaFormateada);
        this.calcularSemana();
    },
    async mounted(){
        this.setLoading(false);
        this.loading = true;
        this.cargarCirculos = true;
        
        try{
            //OBTENER LAS HORAS DIARIAS A PARTIR DEL HORARIO
            let respuesta = await axios.get(`/api/horarios/${this.authUser.id}`); //Obtener el horario del usuario
            let horarios = respuesta.data;
            for (const dia in this.horasDiarias) { //Calculo de las trabajadas por el ususario cada dia
                let horario = horarios.filter(h => h.dia == dia)[0];
                let h1 = (horario.entradaManana).split(":");
                let h2 = (horario.salidaManana).split(":");

                let t1 = new Date();
                let t2 = new Date();
                t1.setHours(h1[0], h1[1]);
                t2.setHours(h2[0], h2[1]);
                
                t1.setHours(t2.getHours() - t1.getHours(), t2.getMinutes() - t1.getMinutes());//Calculo de la diferencia de horas
                let horasManana = (t1.getHours() ? t1.getHours() : "0") + "."+ (t1.getMinutes() ? (t1.getMinutes()/0.6) : "0");

                h1 = (horario.entradaTarde).split(":");
                h2 = (horario.salidaTarde).split(":");
                
                t1 = new Date();
                t2 = new Date();
                t1.setHours(h1[0], h1[1]);
                t2.setHours(h2[0], h2[1]);
                
                t1.setHours(t2.getHours() - t1.getHours(), t2.getMinutes() - t1.getMinutes());//Calculo de la diferencia de horas
                let horasTarde= (t1.getHours() ? t1.getHours() : "0") + "."+ (t1.getMinutes() ? (t1.getMinutes()/0.6) : "0");

                this.horasDiarias[dia] = parseFloat(horasManana) + parseFloat(horasTarde);
            }
            
            this.fechaFormateada = this.formatDate(new Date().toISOString().substr(0, 10));
            this.fecha = this.parseDate(this.fechaFormateada);
            this.calcularPorcentaje();

            //OBTENER PARTES ACTIVOS, PDTE. FINALIZAR Y/O EN ANALISIS SEGUIDOS POR EL USUARIO LOGEADO
            let params = {
                idsEstadosParteSeleccionados: [1,2,6],
                followedBy: [this.authUser.id]
            }
            respuesta = await axios.get("/api/partes", { params });
            // console.log(respuesta);
            this.partesFollowed = respuesta.data;
            
            //OBTENER LOS CINCO CLIENTES MAS FACTURADOS (LOS ULTIMOS 30 DIAS) DEL USUARIO LOGEADO 
            let agruparHoras = [];
            respuesta = await axios.get("/api/acciones"); //Obtener acciones del usuario logeado
            this.accionesUsuario = respuesta.data;
            
            this.accionesUsuario.forEach(accion => { //recontamos la cantidad de horas dedicadas a cada cliente
                console.log(accion)
                if(agruparHoras[accion.parte.cliente]){
                    agruparHoras[accion.parte.cliente] = agruparHoras[accion.parte.cliente] + accion.horasPonderadas + accion.horasDesplazamiento;
                }else{
                    agruparHoras[accion.parte.cliente] = accion.horasPonderadas + accion.horasDesplazamiento;
                }
            });
            for(var key in agruparHoras){ //cambiamos el formato del array a un array de objetos
                if(agruparHoras.hasOwnProperty(key)){
                    this.facturacionClientes.push({ 'cliente': key, 'facturacion': agruparHoras[key].toFixed(2) });
                }
            }  
            this.facturacionClientes.sort(function(a, b){ return b.facturacion-a.facturacion; }); //ordenamos el array obtenido de mas a menos horas facturadas
            this.facturacionClientes = this.facturacionClientes.slice(0, 5); //nos quedamos con los 5 clientes mas facturados
            
            //OBTENER TIMERS DEL USUARIO LOGEADO
            respuesta = await axios.get("/api/arditimers");
            let timers = respuesta.data.length;
            respuesta = await axios.get('/api/arditimersGrupos');
            this.timersUsuario = timers + respuesta.data.length;
            
            this.loading = false;
        }catch(error){
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido cargar los datos'
            });
            this.loading = false;
            console.log(error);
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'setLoading']),
        saludar(){
            let hoy = new Date();
            let hora = hoy.getHours() < 10 ? '0' + hoy.getHours() : hoy.getHours();  
            
            if(hora >= 6 && hora < 15){
                return 'Buenos días';
            }else if(hora >= 15 && hora < 20){
                return 'Buenas tardes';
            }else{
                return 'Buenas noches';
            }
        },
        calcularSemana(){ //OBTENEMOS LOS DIA DE LA SEMANA SELECCIONADA DE LUNES A VIERNES
            let dias = 0    
            let f = new Date(this.fecha);
            let nDiaSemana = f.getUTCDay(); //obtenemos la posicion del dia en la smena
            //calcula los dias que se tienen que restar para estar en lunes
            if(nDiaSemana==0){ //si es domingo
                dias=(-6);        
            }else{ //el resto de dias
                dias=(nDiaSemana-1)*(-1);   
            }
            
            f.setDate(f.getDate() + dias);
            this.semana.lunes = this.formatDate(f.toISOString().substr(0, 10));
            
            f.setDate(f.getDate() + 1);
            this.semana.martes = this.formatDate(f.toISOString().substr(0, 10));
            f.setDate(f.getDate() + 1);
            this.semana.miercoles = this.formatDate(f.toISOString().substr(0, 10));
            f.setDate(f.getDate() + 1);
            this.semana.jueves = this.formatDate(f.toISOString().substr(0, 10));
            
            f.setDate(f.getDate() + 1);
            this.semana.viernes = this.formatDate(f.toISOString().substr(0, 10));

            this.calcularPorcentaje();
        },
        async calcularPorcentaje(){
            let respuesta = await axios.get(`/api/acciones?lunes=${this.parseDate(this.semana.lunes)}&ultimoDia=${this.parseDate(this.semana.viernes)}`); //Recuperar las acciones del usuario relizadas la semana indicada
            let accionesSemana = respuesta.data;
            this.facturacionDiaria = { 
                lunes: 0,
                martes: 0,
                miercoles: 0,
                jueves: 0,
                viernes: 0,
                mediaSemanal: 0
            };
            this.porcentajeFacturacion = {
                lunes: 0,
                martes: 0,
                miercoles: 0,
                jueves: 0,
                viernes: 0,
                mediaSemanal: 0
            };
            accionesSemana.forEach(accion => {
                switch (accion.fecha) {
                    case this.parseDate(this.semana.lunes):
                        this.facturacionDiaria.lunes += accion.horasBonus+accion.horasDesplazamiento;
                        break;
                    case this.parseDate(this.semana.martes):
                        this.facturacionDiaria.martes += accion.horasBonus+accion.horasDesplazamiento;
                        break;
                    case this.parseDate(this.semana.miercoles):
                        this.facturacionDiaria.miercoles += accion.horasBonus+accion.horasDesplazamiento;
                        break;
                    case this.parseDate(this.semana.jueves):
                        this.facturacionDiaria.jueves += accion.horasBonus+accion.horasDesplazamiento;
                        break;
                    case this.parseDate(this.semana.viernes):
                        this.facturacionDiaria.viernes += accion.horasBonus+accion.horasDesplazamiento;
                        break;
                }
            });
            let horasTotales = 0;
            for (const dia in this.facturacionDiaria) { 
                if(this.facturacionDiaria[dia] !== 0 && dia != 'mediaSemanal'){
                    this.facturacionDiaria.mediaSemanal += this.facturacionDiaria[dia];
                    horasTotales = horasTotales + this.horasDiarias[dia];
                    
                    this.porcentajeFacturacion[dia] = (this.facturacionDiaria[dia] * 100) / this.horasDiarias[dia];
                }
            }
            if(this.facturacionDiaria.mediaSemanal != 0){
                this.porcentajeFacturacion.mediaSemanal = (this.facturacionDiaria.mediaSemanal * 100) / horasTotales;  
            }else{
                this.porcentajeFacturacion= {
                    lunes: 0,
                    martes: 0,
                    miercoles: 0,
                    jueves: 0,
                    viernes: 0,
                    mediaSemanal: 0
                }
            }
        },
        getColor(porcentaje){
            if(porcentaje < 25){
                return 'red';
            }else if(porcentaje >= 25 && porcentaje < 45){
                return 'orange';
            }else if(porcentaje >= 45 && porcentaje < 60){
                return 'yellow';
            }else if(porcentaje >= 60 && porcentaje < 75){
                return 'light-green';
            }else{
                return 'green darken-2';
            }
        },
        colorFondo(item) {
            if (item.fechaFidelizacion == null) { //si no tiene fecha de fidelización pintamos el fondo de gris
                if(this.$vuetify.theme.dark){
                    return "grey darken-3";
                }else{
                    return "grey lighten-3";
                }
            } 
        }
    },
    computed: {
        ...mapState('login', ['authUser'])
    },
    watch: {
      fecha (val) {
        this.fechaFormateada = this.formatDate(this.fecha)
      },
    },
    components: {
        Fidelizaciones
    },
}
</script>
<style>
    .deshabilitado {
        background-color: rgb(215,215,44)
    }
</style>